import React from 'react';
import ipImage from '../../images/ip-homepage.PNG';
import providenceImage from '../../images/providence-homepage.PNG';

import './experience.scss';

const Experience = () => {
   return (
      <>
      <div className='exp-container d-flex justify-content-center align-items-center'>
         <div className='exp-left-bar' style={{backgroundColor: '#49b'}}></div>
         
         <div className='exp d-flex'>
            <div className='exp-img'>
               <div className='exp-img-hover'>
                  <a 
                     className='exp-img-hover-button d-flex justify-content-center align-items-center'
                     href='https://providencebp.vercel.app/bookstore'
                     target='_blank'
                     rel="noopener noreferrer"
                  >
                     <div className='btn btn-light'>Visit website</div>
                  </a>
                  <img src={providenceImage} alt='Inheritance Publication Online Store'/>
               </div>
            </div>

            <div className='exp-details'>
               <div className='exp-details-h3 d-flex justify-content-between align-items-center'>
                  <div className='exp-h3-bg'></div>
                  <h3>Providence Books &amp; Press - Freelance Project</h3>
                  <div>Mar 2021 - today</div>
               </div>
               <div className='exp-details-info'>
                  <ul>
                     <li>Design and develop an e-commerce website to sell the company’s products</li>
                     <li>The project will contain user authentication to allow users to have a better experience and relationship with the company.</li>
                     <li>The website will also be a plataform for Christian articles and texts which users may interact with by leaving their comments.</li>
                     <li>A built-in review system will help customers to choose the right products</li>
                     <li>At last, an admin panel will be developed to allow the management of database, website content, history of purchases and user information</li>
                  </ul>
               </div>
            </div>
         </div>
      </div>


      <div className='exp-container d-flex justify-content-center align-items-center'>
         <div className='exp-left-bar'></div>
         
         <div className='exp d-flex'>
            <div className='exp-img'>
               <div className='exp-img-hover'>
                  <a 
                     className='exp-img-hover-button d-flex justify-content-center align-items-center'
                     href='https://inhpubli.now.sh/'
                     target='_blank'
                     rel="noopener noreferrer"
                  >
                     <div className='btn btn-light'>Visit website</div>
                  </a>
                  <img src={ipImage} alt='Inheritance Publication Online Store'/>
               </div>
            </div>

            <div className='exp-details'>
               <div className='exp-details-h3 d-flex justify-content-between align-items-center'>
                  <div className='exp-h3-bg'></div>
                  <h3>Inheritance Publications</h3>
                  <div>May 2020 - today</div>
               </div>
               <div className='exp-details-info'>
                  <p>I first started developing the company's website on October 2019 and it was completely delivered on May 2020. Before the final deployment I received a job offer from the CEO to be developer and maintainer of the website.</p>
                  <p>My duties as web developer at Inheritance Publications are, but not limited to:</p>
                  <ul>
                     <li>Improve the architecture and layout of the website as well as determining the requirements needed to achieve such improvement</li>
                     <li>Create and optimize content for the website</li>
                     <li>Develop a database with all products data and other data essential to the correct functioning of the application</li>
                     <li>Maintain website and its database in order to ensure availability</li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
      </>
   )
}

export default Experience
